(function(){
    'use strict'

    angular.module('app.procesarPlanilla')
    .factory('ProcesarPlanillaService', ProcesarPlanillaService);

    ProcesarPlanillaService.$inject = ['$http', 'apiSettings', 'UserInfoService'];

    function ProcesarPlanillaService($http, apiSettings, UserInfoService) {

        var api = {
            getPlanillaProcesada:getPlanillaProcesada,
            searchPlanillaProcesada: searchPlanillaProcesada,
            getPlanillaProcesadaDetalle: getPlanillaProcesadaDetalle,
            updateCantidad: updateCantidad,
            updateDeduccion: updateDeduccion,
            updateDevengado: updateDevengado,
            save: save,
            recalcular: recalcular,
            cerrar: cerrar,
            eliminarEmpleado: eliminarEmpleado,
            getEmpleadosAAgregarEnPlanilla: getEmpleadosAAgregarEnPlanilla,
            agregarEmpleado: agregarEmpleado
        };

        return api;

        function getPlanillaProcesada(calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/planillas-procesadas/' + UserInfoService.getCompaniaId() + '/' + calendarizacionId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getPlanillaProcesadaDetalle(calendarizacionId, empleadoId){

            var url = apiSettings.apiBaseUrl + 'api/planillas-procesadas-detalle/' + UserInfoService.getCompaniaId() + '/' + empleadoId + '/' + calendarizacionId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function save(calendarizacion){

            if(!calendarizacion.companiaId){
                calendarizacion.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/procesar-planillas/',  
                method: 'POST',  
                data: calendarizacion
            });  
            return response;
        };

        function recalcular(calendarizacion){

            if(!calendarizacion.companiaId){
                calendarizacion.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/procesar-planillas/recalcular',  
                method: 'POST',  
                data: calendarizacion
            });  
            return response;
        };
        
        function cerrar(calendarizacion){

            if(!calendarizacion.companiaId){
                calendarizacion.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/procesar-planillas/cerrar',  
                method: 'POST',  
                data: calendarizacion
            });  
            return response;
        }; 
        
        function eliminarEmpleado(datos){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/procesar-planillas/eliminar-empleado',  
                method: 'POST',  
                data: datos
            });  
            return response;
        };   

        function searchPlanillaProcesada(searchCriteria){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/planillas-procesadas/search',  
                method: 'POST',  
                data: searchCriteria
            });  
            return response;
        };

        function updateCantidad(cantidad){

            if(!cantidad.companiaId){
                cantidad.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/planillas-procesadas-detalle/editar-cantidad/',  
                method: 'PUT',  
                data: cantidad
            });  
            return response;
        };

        function updateDeduccion(deduccion){

            if(!deduccion.companiaId){
                deduccion.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/planillas-procesadas-detalle/editar-deduccion/',  
                method: 'PUT',  
                data: deduccion
            });  
            return response;
        };

        function updateDevengado(devengado){

            if(!devengado.companiaId){
                devengado.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/planillas-procesadas-detalle/editar-devengado/',  
                method: 'PUT',  
                data: devengado
            });  
            return response;
        };

        function getEmpleadosAAgregarEnPlanilla(calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/planillas-procesadas/empleados-a-agregar/' + UserInfoService.getCompaniaId() + '/' + calendarizacionId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function agregarEmpleado(calendarizacionId, empleadoId){

            var model = {
                companiaId: UserInfoService.getCompaniaId(),
                calendarizacionId: calendarizacionId,
                empleadoId: empleadoId
            };

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/planillas-procesadas/agregar-empleado',  
                method: 'POST',  
                data: model
            });  
            return response;
        };

    };

})();